import { render } from "./AddStepzero.vue?vue&type=template&id=dc5a3664&scoped=true"
import script from "./AddStepzero.vue?vue&type=script&lang=js"
export * from "./AddStepzero.vue?vue&type=script&lang=js"

import "./AddStepzero.vue?vue&type=style&index=0&id=dc5a3664&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc5a3664"]])

export default __exports__